import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=31c34598&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=31c34598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c34598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c34598')) {
      api.createRecord('31c34598', component.options)
    } else {
      api.reload('31c34598', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=31c34598&scoped=true&", function () {
      api.rerender('31c34598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85aCiZ4xA6Rje/JS/comp/DocBox.vue"
export default component.exports